  import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AnnouncementService {

  constructor(private readonly http: HttpClient) {
  }

  extractData(res: any) {
    return res;
  }

  getActiveAnnouncements(): Observable<any[]> {
    return this.http.get<any[]>(`/dashboard/announcement/announcements/activeAnnouncements`).pipe(map(this.extractData));
  }
}
